import React from 'react';
import {
  Table, TableHead, TableBody, TableCell, TableRow, makeStyles,
} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import { CommonButton } from '../../CommonComponents';

const useStyles = makeStyles((theme) => ({
  problemWithSite: {
    backgroundColor: theme.palette.warning.main,
  },
  regularRow: {},
}))
export default function ManagerSubTable({
  id, open, managerProducts, setLocalState,
}) {
  const classes = useStyles();
  if (managerProducts === undefined) { return null }
  return (
    <>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {managerProducts.length ? (
              <Box margin={1}>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell><b>Company Name</b></TableCell>
                      <TableCell><b>Client Name</b></TableCell>
                      <TableCell><b>Product Name</b></TableCell>
                      <TableCell><b>Action</b></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {managerProducts.map((prod) => (
                      <TableRow
                        key={prod.productId}
                        className={classes.regularRow}
                      >
                        <TableCell component="th" scope="row">
                          {prod.product && prod.product.client
                          && prod.product.client.company && prod.product.client.company.CompanyName}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {prod.product && prod.product.client && prod.product.client.clientName}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {prod.product && prod.product.productName}
                        </TableCell>
                        <TableCell>
                          <CommonButton
                            onClick={() => setLocalState({
                              userId: id,
                              productId: prod.productId,
                              alert: true,
                            })}
                            basic="true"
                            color="primary"
                          >
                            <b>Remove</b>
                          </CommonButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            ) : (
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div">No reports available</Typography>
              </Box>
            )}
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
